import type { AppRoutes } from "@fero/utils";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { Button, Divider, Paper, Stack, Typography } from "@mui/material";

interface Props {
  title: string;
  body: string;
  buttonProps: { label: string; route: AppRoutes };
}

export const ReminderCard = ({ title, body, buttonProps }: Props) => {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2} alignItems="center">
        <Paper
          elevation={0}
          sx={{
            backgroundColor: "warning.light",
            p: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <WarningRoundedIcon sx={{ color: "warning.main" }} />
        </Paper>
        <Stack spacing={1} alignItems="center">
          <Typography textAlign="center" variant="body1Bold">
            {title}
          </Typography>
          <Typography textAlign="center">{body}</Typography>
        </Stack>

        <Stack width="100%" spacing={2}>
          <Divider />
          <Button href={buttonProps.route} disableElevation color="warning">
            {buttonProps.label}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
};
